export const numberAndCommaRegExp = /^[\d,]+$/;
